import React, { useContext } from 'react';
import ProcanvasSlider from '../../../../../common/procanvasSlider';
import { MarkupContext } from '../../../contexts';

const OpacitySlider = () => {
  const { opacity, updateOpacity } = useContext(MarkupContext);
  return (
    <div className="markups-opacity -new-slider">
      <h3>Opacity:</h3>
      <ProcanvasSlider
        min={ 0 }
        max={ 0.7 }
        step={ 0.0001 }
        value={ opacity }
        onChange={ updateOpacity }
      />
    </div>
  );
};

export default OpacitySlider;
